module.exports = __webpack_public_path__ + "static/media/realtimerounded-bold.69c9a0c1.woff";